import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import useTimezone from './useTimezone';

const TimezoneContext = createContext(null);

export function TimezoneProvider({ children }) {
  const { timezone, setTimezone } = useTimezone();
  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
}

TimezoneProvider.propTypes = {
  children: PropTypes.node,
};

export function useTimezoneContext() {
  return useContext(TimezoneContext);
}
